import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-76ab84fa.js';
import React, { useState, useEffect } from 'react';

require("es6-promise").polyfill();

var WeducLogin = function WeducLogin(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2);

  _useState2[0];
  _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2);

  _useState4[0];
  _useState4[1];
  useEffect(function () {
    !function () {
      var entityID = props.entity ? props.entity : "281474976810657";
      var e = document.getElementById("login-".concat(entityID)),
          t = window.addEventListener ? "addEventListener" : "attachEvent";
      (0, window[t])("attachEvent" == t ? "onmessage" : "message", function (t) {
        e.height = t.data.height + 10, e.width = t.data.width;
      }, !1);
    }();
  }, []);
  var Html = props.html || /*#__PURE__*/React.createElement("div", {
    className: "weduc-login-wrap"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: "https://app.weduc.co.uk/main/remote/login/entity/".concat(props.entity ? props.entity : "281474976810657", "/localeCode/").concat(props.localeCode ? props.localeCode : "en_GB"),
    id: "login-".concat(props.entity ? props.entity : "281474976810657"),
    frameborder: "0",
    marginheight: "0",
    marginwidth: "0",
    className: "responsive-iframe weduc-login",
    title: "Login with Weduc",
    width: "100%"
  }));
  return Html;
};

export default WeducLogin;